import {
  INCIDENT_FOLDERS_SET,
  INCIDENT_FOLDER_EDITED,
  INCIDENT_FOLDER_ADDED,
  INCIDENT_FOLDER_DELETED,
} from 'src/app/redux/redux-types';
import { reduxIncidentFolderTypes } from 'src/types';

export const incidentFolderDefaultState: reduxIncidentFolderTypes.StateType = {
  incidentFolderList: [],
};

export const incidentFolderReducer = (
  state = incidentFolderDefaultState,
  action: reduxIncidentFolderTypes.ActionType,
): reduxIncidentFolderTypes.StateType => {
  switch (action.type) {
    case INCIDENT_FOLDERS_SET:
      return {
        ...state,
        incidentFolderList: action.payload,
      };
    case INCIDENT_FOLDER_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.incidentFolderList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        incidentFolderList: [action.payload, ...state.incidentFolderList],
      };
    case INCIDENT_FOLDER_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.incidentFolderList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        incidentFolderList: [
          ...state.incidentFolderList.slice(0, updateIndex),
          action.payload,
          ...state.incidentFolderList.slice(updateIndex + 1),
        ],
      };
    case INCIDENT_FOLDER_DELETED:
      return {
        ...state,
        incidentFolderList: state.incidentFolderList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
